// GENERATED FILE — DO NOT EDIT.
// Source: packages/design-tokens/tokens.json (single source of truth, MASTER_SPEC §14.1.1).
// Regenerate: node packages/design-tokens/scripts/generate.mjs
// This file is exempt from the raw-color lint (scripts/lint/check-raw-colors.sh).

export type StatusDomain = 'order' | 'payment' | 'driver' | 'settlement' | 'subscription' | 'promotion';

/** Wire: contracts/openapi/orders.yaml OrderStatus (§3.3) */
export type OrderStatusCode = 'PENDING' | 'CONFIRMED' | 'IN_DELIVERY' | 'DELIVERED' | 'RETURNED' | 'CANCELLED' | 'SCHEDULED';

/** Wire: contracts/openapi/payments.yaml TxnStatus (§5.3) */
export type PaymentStatusCode = 'INITIATED' | 'PENDING' | 'SUCCEEDED' | 'FAILED' | 'REFUNDED' | 'PARTIALLY_REFUNDED' | 'CANCELLED';

/** Wire: contracts/openapi/drivers.yaml DriverAvailability (§8.2) */
export type DriverStatusCode = 'ONLINE' | 'OFFLINE' | 'ON_DELIVERY' | 'BLOCKED';

/** Wire: contracts/openapi/settlement.yaml SettlementRecord.status (§8.3) */
export type SettlementStatusCode = 'DRAFT' | 'PENDING' | 'SETTLED' | 'VOID' | 'DISPUTED';

/** Wire: contracts/openapi/subscriptions.yaml Subscription.status (§7) */
export type SubscriptionStatusCode = 'ACTIVE' | 'EXPIRING' | 'EXPIRED' | 'RENEWED' | 'CANCELLED';

/** Wire: contracts/openapi/promotions.yaml PromotionStatus (§4.4) */
export type PromotionStatusCode = 'DRAFT' | 'ACTIVE' | 'PAUSED' | 'ENDED' | 'ARCHIVED';

export type StatusCode = OrderStatusCode | PaymentStatusCode | DriverStatusCode | SettlementStatusCode | SubscriptionStatusCode | PromotionStatusCode;

export interface StatusStyle {
  readonly domain: StatusDomain;
  readonly code: string;
  /** Canonical i18n values (§14.2); apps key their translation files by code. */
  readonly label: { readonly ar: string; readonly en: string };
  /** lucide-react icon name (fixed per §14.1 — identical metaphor on Flutter). */
  readonly lucideIcon: string;
  /** Mode-aware CSS custom properties from tokens.generated.css. */
  readonly cssVars: { readonly color: string; readonly container: string; readonly onContainer: string };
  /** Status exists in the token map ahead of its feature (e.g. SCHEDULED). */
  readonly future?: true;
}

export const STATUS_MAP = {
  order: {
    PENDING: {
      domain: 'order',
      code: 'PENDING',
      label: { ar: 'قيد الانتظار', en: 'Pending' },
      lucideIcon: 'clock',
      cssVars: { color: '--status-order-pending-color', container: '--status-order-pending-container', onContainer: '--status-order-pending-on-container' },
    },
    CONFIRMED: {
      domain: 'order',
      code: 'CONFIRMED',
      label: { ar: 'مؤكد', en: 'Confirmed' },
      lucideIcon: 'user-check',
      cssVars: { color: '--status-order-confirmed-color', container: '--status-order-confirmed-container', onContainer: '--status-order-confirmed-on-container' },
    },
    IN_DELIVERY: {
      domain: 'order',
      code: 'IN_DELIVERY',
      label: { ar: 'قيد التوصيل', en: 'In Delivery' },
      lucideIcon: 'bike',
      cssVars: { color: '--status-order-in-delivery-color', container: '--status-order-in-delivery-container', onContainer: '--status-order-in-delivery-on-container' },
    },
    DELIVERED: {
      domain: 'order',
      code: 'DELIVERED',
      label: { ar: 'تم التسليم', en: 'Delivered' },
      lucideIcon: 'check-circle-2',
      cssVars: { color: '--status-order-delivered-color', container: '--status-order-delivered-container', onContainer: '--status-order-delivered-on-container' },
    },
    RETURNED: {
      domain: 'order',
      code: 'RETURNED',
      label: { ar: 'راجع', en: 'Returned' },
      lucideIcon: 'undo-2',
      cssVars: { color: '--status-order-returned-color', container: '--status-order-returned-container', onContainer: '--status-order-returned-on-container' },
    },
    CANCELLED: {
      domain: 'order',
      code: 'CANCELLED',
      label: { ar: 'ملغي', en: 'Cancelled' },
      lucideIcon: 'x-circle',
      cssVars: { color: '--status-order-cancelled-color', container: '--status-order-cancelled-container', onContainer: '--status-order-cancelled-on-container' },
    },
    SCHEDULED: {
      domain: 'order',
      code: 'SCHEDULED',
      label: { ar: 'مجدول', en: 'Scheduled' },
      lucideIcon: 'calendar-clock',
      cssVars: { color: '--status-order-scheduled-color', container: '--status-order-scheduled-container', onContainer: '--status-order-scheduled-on-container' },
      future: true,
    },
  },
  payment: {
    INITIATED: {
      domain: 'payment',
      code: 'INITIATED',
      label: { ar: 'قيد الإنشاء', en: 'Initiated' },
      lucideIcon: 'circle-dashed',
      cssVars: { color: '--status-payment-initiated-color', container: '--status-payment-initiated-container', onContainer: '--status-payment-initiated-on-container' },
    },
    PENDING: {
      domain: 'payment',
      code: 'PENDING',
      label: { ar: 'قيد المعالجة', en: 'Pending' },
      lucideIcon: 'clock',
      cssVars: { color: '--status-payment-pending-color', container: '--status-payment-pending-container', onContainer: '--status-payment-pending-on-container' },
    },
    SUCCEEDED: {
      domain: 'payment',
      code: 'SUCCEEDED',
      label: { ar: 'ناجحة', en: 'Succeeded' },
      lucideIcon: 'check-circle-2',
      cssVars: { color: '--status-payment-succeeded-color', container: '--status-payment-succeeded-container', onContainer: '--status-payment-succeeded-on-container' },
    },
    FAILED: {
      domain: 'payment',
      code: 'FAILED',
      label: { ar: 'فاشلة', en: 'Failed' },
      lucideIcon: 'octagon-x',
      cssVars: { color: '--status-payment-failed-color', container: '--status-payment-failed-container', onContainer: '--status-payment-failed-on-container' },
    },
    REFUNDED: {
      domain: 'payment',
      code: 'REFUNDED',
      label: { ar: 'مستردة', en: 'Refunded' },
      lucideIcon: 'undo-2',
      cssVars: { color: '--status-payment-refunded-color', container: '--status-payment-refunded-container', onContainer: '--status-payment-refunded-on-container' },
    },
    PARTIALLY_REFUNDED: {
      domain: 'payment',
      code: 'PARTIALLY_REFUNDED',
      label: { ar: 'مستردة جزئياً', en: 'Partially Refunded' },
      lucideIcon: 'undo-dot',
      cssVars: { color: '--status-payment-partially-refunded-color', container: '--status-payment-partially-refunded-container', onContainer: '--status-payment-partially-refunded-on-container' },
    },
    CANCELLED: {
      domain: 'payment',
      code: 'CANCELLED',
      label: { ar: 'ملغاة', en: 'Cancelled' },
      lucideIcon: 'x-circle',
      cssVars: { color: '--status-payment-cancelled-color', container: '--status-payment-cancelled-container', onContainer: '--status-payment-cancelled-on-container' },
    },
  },
  driver: {
    ONLINE: {
      domain: 'driver',
      code: 'ONLINE',
      label: { ar: 'متصل', en: 'Online' },
      lucideIcon: 'circle-dot',
      cssVars: { color: '--status-driver-online-color', container: '--status-driver-online-container', onContainer: '--status-driver-online-on-container' },
    },
    OFFLINE: {
      domain: 'driver',
      code: 'OFFLINE',
      label: { ar: 'غير متصل', en: 'Offline' },
      lucideIcon: 'circle-off',
      cssVars: { color: '--status-driver-offline-color', container: '--status-driver-offline-container', onContainer: '--status-driver-offline-on-container' },
    },
    ON_DELIVERY: {
      domain: 'driver',
      code: 'ON_DELIVERY',
      label: { ar: 'قيد التوصيل', en: 'On Delivery' },
      lucideIcon: 'bike',
      cssVars: { color: '--status-driver-on-delivery-color', container: '--status-driver-on-delivery-container', onContainer: '--status-driver-on-delivery-on-container' },
    },
    BLOCKED: {
      domain: 'driver',
      code: 'BLOCKED',
      label: { ar: 'محظور', en: 'Blocked' },
      lucideIcon: 'ban',
      cssVars: { color: '--status-driver-blocked-color', container: '--status-driver-blocked-container', onContainer: '--status-driver-blocked-on-container' },
    },
  },
  settlement: {
    DRAFT: {
      domain: 'settlement',
      code: 'DRAFT',
      label: { ar: 'مسودة', en: 'Draft' },
      lucideIcon: 'pencil',
      cssVars: { color: '--status-settlement-draft-color', container: '--status-settlement-draft-container', onContainer: '--status-settlement-draft-on-container' },
    },
    PENDING: {
      domain: 'settlement',
      code: 'PENDING',
      label: { ar: 'قيد الانتظار', en: 'Pending' },
      lucideIcon: 'clock',
      cssVars: { color: '--status-settlement-pending-color', container: '--status-settlement-pending-container', onContainer: '--status-settlement-pending-on-container' },
    },
    SETTLED: {
      domain: 'settlement',
      code: 'SETTLED',
      label: { ar: 'مُسوّاة', en: 'Settled' },
      lucideIcon: 'check-circle-2',
      cssVars: { color: '--status-settlement-settled-color', container: '--status-settlement-settled-container', onContainer: '--status-settlement-settled-on-container' },
    },
    VOID: {
      domain: 'settlement',
      code: 'VOID',
      label: { ar: 'لاغية', en: 'Void' },
      lucideIcon: 'circle-slash',
      cssVars: { color: '--status-settlement-void-color', container: '--status-settlement-void-container', onContainer: '--status-settlement-void-on-container' },
    },
    DISPUTED: {
      domain: 'settlement',
      code: 'DISPUTED',
      label: { ar: 'متنازع عليها', en: 'Disputed' },
      lucideIcon: 'triangle-alert',
      cssVars: { color: '--status-settlement-disputed-color', container: '--status-settlement-disputed-container', onContainer: '--status-settlement-disputed-on-container' },
    },
  },
  subscription: {
    ACTIVE: {
      domain: 'subscription',
      code: 'ACTIVE',
      label: { ar: 'نشط', en: 'Active' },
      lucideIcon: 'badge-check',
      cssVars: { color: '--status-subscription-active-color', container: '--status-subscription-active-container', onContainer: '--status-subscription-active-on-container' },
    },
    EXPIRING: {
      domain: 'subscription',
      code: 'EXPIRING',
      label: { ar: 'يوشك على الانتهاء', en: 'Expiring' },
      lucideIcon: 'hourglass',
      cssVars: { color: '--status-subscription-expiring-color', container: '--status-subscription-expiring-container', onContainer: '--status-subscription-expiring-on-container' },
    },
    EXPIRED: {
      domain: 'subscription',
      code: 'EXPIRED',
      label: { ar: 'منتهي', en: 'Expired' },
      lucideIcon: 'calendar-x',
      cssVars: { color: '--status-subscription-expired-color', container: '--status-subscription-expired-container', onContainer: '--status-subscription-expired-on-container' },
    },
    RENEWED: {
      domain: 'subscription',
      code: 'RENEWED',
      label: { ar: 'مُجدَّد', en: 'Renewed' },
      lucideIcon: 'refresh-cw',
      cssVars: { color: '--status-subscription-renewed-color', container: '--status-subscription-renewed-container', onContainer: '--status-subscription-renewed-on-container' },
    },
    CANCELLED: {
      domain: 'subscription',
      code: 'CANCELLED',
      label: { ar: 'ملغي', en: 'Cancelled' },
      lucideIcon: 'x-circle',
      cssVars: { color: '--status-subscription-cancelled-color', container: '--status-subscription-cancelled-container', onContainer: '--status-subscription-cancelled-on-container' },
    },
  },
  promotion: {
    DRAFT: {
      domain: 'promotion',
      code: 'DRAFT',
      label: { ar: 'مسودة', en: 'Draft' },
      lucideIcon: 'pencil',
      cssVars: { color: '--status-promotion-draft-color', container: '--status-promotion-draft-container', onContainer: '--status-promotion-draft-on-container' },
    },
    ACTIVE: {
      domain: 'promotion',
      code: 'ACTIVE',
      label: { ar: 'نشط', en: 'Active' },
      lucideIcon: 'megaphone',
      cssVars: { color: '--status-promotion-active-color', container: '--status-promotion-active-container', onContainer: '--status-promotion-active-on-container' },
    },
    PAUSED: {
      domain: 'promotion',
      code: 'PAUSED',
      label: { ar: 'متوقف مؤقتاً', en: 'Paused' },
      lucideIcon: 'circle-pause',
      cssVars: { color: '--status-promotion-paused-color', container: '--status-promotion-paused-container', onContainer: '--status-promotion-paused-on-container' },
    },
    ENDED: {
      domain: 'promotion',
      code: 'ENDED',
      label: { ar: 'منتهٍ', en: 'Ended' },
      lucideIcon: 'flag',
      cssVars: { color: '--status-promotion-ended-color', container: '--status-promotion-ended-container', onContainer: '--status-promotion-ended-on-container' },
    },
    ARCHIVED: {
      domain: 'promotion',
      code: 'ARCHIVED',
      label: { ar: 'مؤرشف', en: 'Archived' },
      lucideIcon: 'archive',
      cssVars: { color: '--status-promotion-archived-color', container: '--status-promotion-archived-container', onContainer: '--status-promotion-archived-on-container' },
    },
  },
} as const satisfies Record<StatusDomain, Record<string, StatusStyle>>;

/**
 * Where each domain's wire vocabulary is defined. The contracts own the wire
 * spelling; this map only records which enum a domain mirrors.
 */
export const STATUS_WIRE_SOURCES: Readonly<Record<StatusDomain, string>> = {
  order: 'contracts/openapi/orders.yaml OrderStatus (§3.3)',
  payment: 'contracts/openapi/payments.yaml TxnStatus (§5.3)',
  driver: 'contracts/openapi/drivers.yaml DriverAvailability (§8.2)',
  settlement: 'contracts/openapi/settlement.yaml SettlementRecord.status (§8.3)',
  subscription: 'contracts/openapi/subscriptions.yaml Subscription.status (§7)',
  promotion: 'contracts/openapi/promotions.yaml PromotionStatus (§4.4)',
};

/** Case-folded index behind {@link statusStyleForWire} — built once at load. */
const WIRE_INDEX: Record<string, Record<string, StatusStyle>> = Object.fromEntries(
  Object.entries(STATUS_MAP).map(([domain, codes]) => [
    domain,
    Object.fromEntries(Object.entries(codes).map(([code, style]) => [code.toUpperCase(), style as StatusStyle])),
  ]),
);

/**
 * Resolves a RAW WIRE CODE to its fixed style, CASE-INSENSITIVELY (M6-20).
 *
 * Deliberate tolerance, not silent normalization: the contracts disagree on
 * case (payments.yaml `TxnStatus` is lowercase, every other status enum is
 * UPPERCASE) and the wire spelling is the contract's to define, so the
 * presentation layer folds case instead. Only case is tolerated — a code that
 * is genuinely not in the map still returns `undefined`, leaving each
 * consumer's open-enum fallback intact. See tokens.json `status.$resolution`.
 */
export function statusStyleForWire(domain: StatusDomain, wireCode: string): StatusStyle | undefined {
  return WIRE_INDEX[domain]?.[wireCode.toUpperCase()];
}

/**
 * Categorical chart series (M6-01, §14.4) — mode-aware CSS custom properties
 * in FIXED slot order. Assign by entity, never cycle or re-rank on filter;
 * a series beyond the last slot folds into "Other". Validated CVD-safe in
 * both modes against the platform surfaces.
 */
export const CHART_SERIES = [
  '--chart-series-1',
  '--chart-series-2',
  '--chart-series-3',
  '--chart-series-4',
  '--chart-series-5',
  '--chart-series-6',
] as const;
